import(/* webpackMode: "eager" */ "/vercel/path0/src/app/admin/login/page.tsx");
